import { Icon } from 'components';
import React, { useContext } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { ContactDrawerContext } from '../../../contexts';
import { ContactMatchParams } from '../types';
import {
  ActionHeader,
  Container,
  ContentContainer,
  GoBackIconContainer,
  ProfileContainer,
} from './Content/common';
import CoopDrawerDetails from './Details/CoopDrawerDetails';
import CoopDrawerProfile from './Profile/CoopDrawerProfile';

interface CoopDrawerContentProps
  extends RouteComponentProps<ContactMatchParams> {
  parentHistory: any;
}

const CoopDrawerContent: React.FC<CoopDrawerContentProps> = () => {
  const { closeContactDrawer, coopContact } = useContext(ContactDrawerContext);

  return (
    <Container>
      <ActionHeader>
        <GoBackIconContainer
          onClick={() => closeContactDrawer()}
          data-cy="contact-close-icon"
        >
          <Icon type="x-alt" width={12} height={12} color="black" />
        </GoBackIconContainer>
      </ActionHeader>

      <ContentContainer>
        <>
          <ProfileContainer>
            <CoopDrawerProfile contact={coopContact} />
          </ProfileContainer>
          <CoopDrawerDetails contact={coopContact} />
        </>
      </ContentContainer>
    </Container>
  );
};

export default CoopDrawerContent;
